import { render, staticRenderFns } from "./buyer-manage.vue?vue&type=template&id=0242d985&scoped=true&"
import script from "./buyer-manage.vue?vue&type=script&lang=js&"
export * from "./buyer-manage.vue?vue&type=script&lang=js&"
import style0 from "./buyer-manage.vue?vue&type=style&index=0&id=0242d985&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0242d985",
  null
  
)

export default component.exports